import React, { useEffect } from 'react';
import './PresenceMap.css'

const PresenceMap = () => {
  useEffect(() => {
    // Load the Google Charts library
    window.google.charts.load('current', {
      packages: ['map'],
      mapsApiKey: 'AIzaSyDW4Toc2G4AcdCCoyKSY3i3dvi5-PAx1dc'
    });

    // Once loaded, draw the map
    window.google.charts.setOnLoadCallback(drawMap);

    function drawMap() {
      const data = window.google.visualization.arrayToDataTable([
        ['Lat', 'Long', 'Name'],

        [24.244, 55.727, 'AL Ain'],

        [24.357, 54.524, 'Musaffa'],

        [23.596, 58.436, 'Al Khuwair'],

        [23.648, 58.104, 'Mabella'],

        [26.178, 50.538, 'Manama'],

        [24.438, 54.412, 'Karama'],

        [38.499, -98.297, 'kansas'],

        [23.619, 58.545, 'Ruwi'],

        [25.414, 51.498, 'Doha'],

        [51.904, 0.520, 'Essex'],

        [51.522, -0.130, 'London'],

        [53.835, -1.776, 'Yorkshire'],

        [53.149, -1.623, 'Derbyshire'],

        [53.204, -2.927, 'Cheshire'],

        [52.637, -2.686, 'Concord'],

        [53.486, -2.248, 'Manchester'],

        [51.156, -1.220, 'Hampshire'],

        [53.502, -3.000, 'Liverpool'],

        [53.806, -1.549, 'Leeds'],

        [54.427, -0.556, 'South yorkshire'],

        [51.358, -3.062, 'Devon'],

        [52.676, -1.125, 'Leicester'],

        [35.892, 14.446, 'Malta'],

        [54.515, -5.889, 'Carryduff'],

        [54.601, -5.921, 'County Down'],

        [54.447, -124.708, 'British Columbia'],

        [56.440, -114.998, 'Alberta'],

        [51.484, -86.111, 'Ontario'],

        [49.323, -123.121, 'Vancouver'],

        [32.621, -83.126, 'Georgia'],

        [40.175, -89.298, 'Illinois'],

        [40.745, -73.965, 'New York'],

        [46.907, -109.502, 'Montana'],

        [34.340, -111.721, 'Arizona'],

        [36.498, -119.119, 'California'],

        [43.791, -120.519, 'Oregon'],

        [31.503, -99.122, 'Texas'],

        [27.814, -81.687, 'Florida'],

        [29.355, 47.911, 'Kuwait'],

        [-33.826, 151.282, 'Sydney'],

        [26.191, 50.556, 'Tubli'],

        [26.186, 50.527, 'Salmabad'],

        [26.235, 50.652, 'Hidd'],

        [26.226, 50.545, 'Sanabis'],

        [23.586, 58.361, 'Muscat'],

        [23.597, 58.540, 'Ruwi'],

        [23.611, 58.505, 'Wattayah'],

        [23.650, 58.143, 'Seeb'],

        [22.727, 58.526, 'Ibra'],

        [24.355, 56.719, 'Sohar'],

        [17.0596, 54.130, 'Salalah'],

        [24.389, 54.594, 'Abu Dhabi'],

        [25.407, 55.517, 'Ajman'],

        [25.338, 55.415, 'Sharjah'],

        [25.715, 55.972, 'Ras al Khaimah'],

        [25.547, 55.548, 'Umm Al Quwain'],

        [25.132, 56.328, 'Fujairah'],

        [24.968, 55.042, 'Jebel Ali'],

        [53.165, -8.020, 'Kilkenny'],

        [7.949, -1.130, 'Ghana'],

        [-41.292, 174.776, 'Wellington'],

        [33.781, -80.226, 'South Carolina'],

        [25.288, 51.531, 'Doha, Qatar'],

        [23.7407, -103.046, 'Mexico'],

        [25.274, 55.312, 'Blinds and Curtains Dubai'],

        [23.0201818, 72.4396579, 'Gujarat'],

        [37.4214007, -92.0889904, 'missouri'],

        [53.9970856, -6.4196964, 'Dundalk'],

        [55.6645402, -3.7973388, 'Lanarkshire'],

        [53.3859484, -2.6139778, 'Mersey'],

        [39.4888758, -77.0567245, 'Maryland'],

        [52.486919597234504, -2.858233505326408, 'Shropshire'],

        [52.39418532860105, -1.5641727309707598, 'Warwick'],

        [52.087351972423654, -0.2639038483162656, 'Biggleswade'],

        [43.69004525120724, -79.38646936055139, 'Toranto'],

        [-36.8739172406516, 174.74441701005463, 'Auckland'],

        [47.347969351015166, -119.94977022822637, 'Washington'],

        [52.2196975944287, 1.064703629537829, 'Suffolk'],

        [57.088532797852075, -4.299837495672653, 'Scotland'],

        [9.717783668008382, 7.882261434116805, 'Nigeria'],

        [52.49036928381278, -1.8907667671822002, 'West Midlands'],

        [21.513822481755778, 39.226533732127415, 'Jeddah'],

        [41.456111542807434, -82.7070438446286, 'Sandusky'],

        [43.7816343587387, -84.78116753390661, 'Michigan'],

        [26.795159019601154, 73.656262964916, 'Rajasthan'],

        [23.871203862598808, 76.65295889084673, 'Madhya Pradesh'],

        [19.595031009149206, 76.2713431084618, 'Maharashtra'],

        [30.261270177699227, 75.14621052913176, 'Panjab'],

        [14.91838275639556, 75.67422755056322, 'Karnataka'],

        [9.450773887251364, 76.8504254733433, 'Kerala'],

        [11.591113283260382, 78.93362876511256, 'Tamil Nadu'],

        [14.84165295048575, 78.77510220428353, 'Andhra Pradesh'],

        [20.4430397158509, 84.46740705409948, 'Odisha'],

        [22.321717584827564, 82.28570173007432, 'Chhattisgarh'],

        [17.761760601403594, 79.2022122991938, 'Telangana'],

        [29.9989375095724, 78.90308326569846, 'Uttarakhand'],

        [27.985493158225527, 79.77403174425693, 'Uttar Pradesh'],

        [25.79524772303123, 86.0109812633722, 'Bihar'],

        [23.968156644336126, 85.33839886170256, 'Jharkhand'],

        [23.038807669044136, 87.20183804248516, 'West Bengal'],

        [27.457785870850064, 88.35604190406126, 'Sikkim'],

        [26.535565172846276, 92.45116131851267, 'Assam'],

        [28.619346420982403, 95.1537980028236, 'Arunachal Pradesh'],

        [26.064458047253783, 94.5342791643407, 'Nagaland'],

        [24.65044564752475, 93.67017623153404, 'Manipur'],

        [23.453038383429522, 92.79317215303499, 'Mizoram'],

        [23.67704562182855, 91.69100211229657, 'Tripura'],

        [31.772169692551774, 35.21046955246314, 'Jerusalem']
      ]);

      const map = new window.google.visualization.Map(document.getElementById('map_div'));

      map.draw(data, {
        showTooltip: true,
        showInfoWindow: true,
        useMapTypeControl: true
      });
    }
  }, []);

  return (
    <section className="Presence_PAGE">
      <div className="PresencePage_Container">
        <div className="Page-Main_Dec">
          <h1 className="Page-title_UpperCase">Presence</h1>
          <p className="Page_Subtitle-Light">Callistus has Authorized Channel Partners spread across the Globe
            <br />
            having its Presence in GCC, MENA, USA, Europe, UK, Australia, etc. and expanding.</p>
        </div>
        <div className="PresenceMap">
          <div id="map_div"></div>
        </div>
      </div>
    </section>
  );
};

export default PresenceMap;
